import React from "react";
import { useEffect, useRef } from "react";
import "./Modal.scss";

function Modal({ handleClose, show, className, children, lastElementSelector }) {
  const modalWrapperRef = useRef();
  const handleCloseRef = useRef(handleClose);
  const prevShowRef = useRef(show);
  const showHideClass = show ? "modal--open" : "modal--closed";
  const closePopupLabel = window.globalProperties?.["closeModalPopup"]
    ? window.globalProperties?.["closeModalPopup"]
    : "close popup";
  
  // Update ref when handleClose changes
  useEffect(() => {
    handleCloseRef.current = handleClose;
  }, [handleClose]);

  useEffect(() => {
    // Only focus modal when it first opens (show changes from false to true)
    const justOpened = show && !prevShowRef.current;
    prevShowRef.current = show;

    if (!show) return;

    const activeModal = document.querySelector(".modal--open > .modal__main");
    
    if (activeModal && justOpened) {
      activeModal.focus();
    }
    
    if (activeModal) {
      const modal = document.querySelector(".modal--open");
      const prevElSibActiveModal = modal?.previousElementSibling;
      const playBtnImg = prevElSibActiveModal?.querySelector(".btn");
      
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          handleCloseRef.current();
          playBtnImg?.focus();
        }
        // prevents user from leaving modal.
        if(document.activeElement.className === "modal__main" && event.key === "Tab" && event.shiftKey === true){
            event.preventDefault();
            if(lastElementSelector) {
              document.querySelector(lastElementSelector)?.focus();
            }
            else {
              const m = document.querySelector(".modal__main");
              m?.lastChild?.focus();
            }
        }
        else if(lastElementSelector && document.activeElement.matches(lastElementSelector) && event.key === "Tab" && event.shiftKey === false) {
          event.preventDefault();
          document.querySelector(".modal__main")?.focus();
        }
      };

      document.addEventListener("keydown", handleKeyDown);
      
      // Cleanup function to remove event listener
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [show, lastElementSelector]);

  function onClick(event) {
    if(!event || !modalWrapperRef || event.target === modalWrapperRef.current) {
      handleClose();
    }
  }

  return (
    <div className={`modal ${showHideClass} ${className}`} onClick={onClick} ref={modalWrapperRef}>
      <div tabIndex="0" className="modal__main">
        <div className="modal__header">
          <button className={`modal__button darticon-close`} tabIndex="0" onClick={() => handleClose()}
            title={closePopupLabel}
            aria-label={closePopupLabel}
            type="button"></button>
        </div>
        {children}
        {/* Fallback for if no selector is provided, doesn't stop  forward-tabbing, but stops back-tabbing*/}
        {!lastElementSelector && (
          <div tabIndex="0"></div>
        )}
      </div>
    </div>
  );
}

export default Modal;
